
import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { google } from 'google-maps';

@Component({ name: 'FlightpathIconMarker' })
export default class FlightpathIconMarker extends Vue {
  @Prop() googleApi!: google;
  @Prop() map!: google.maps.Map<HTMLDivElement>;
  @Prop() marker!: google.maps.MarkerOptions;

  iconMarker = null as google.maps.Marker | null;

  destroyed() {
    this.iconMarker?.setMap(null);
  }

  mounted() {
    this.iconMarker = new this.googleApi.maps.Marker({
      map: this.map,
      position: this.marker.position,
      icon: this.marker.icon
    });
  }

  @Watch('marker')
  onChange() {
    this.iconMarker?.setMap(this.map);
    this.iconMarker?.setPosition(this.marker.position as google.maps.LatLng);
    this.iconMarker?.setIcon(this.marker.icon as google.maps.ReadonlySymbol);
  }
}
